export default __webpack_public_path__ + "static/media/borrower-icon.ac57aa96.jpg";